
import Debug from "@/components/utility/Debug.vue";
import { PaginationFilterListElement } from "@/lib/utility/data/page-filter-list-element.interface";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { PageFilterTypes } from "@/lib/utility/data/page-filter-types.enum";
import { $t } from "@/lib/utility/t";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { PaginationFilterOperationEnum } from "@/store/modules/base-pagination.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IGroupedFilters } from "./FilterCardPaginationSideCard.vue";
import FilterCardPaginationValueField from "./FilterCardPaginationValueField.vue";

@Component({
  components: {
    FilterCardPaginationValueField,
    Debug
  }
})
export default class FilterCardPaginationSideCardFilterElement extends Vue {
  @Prop()
  value!: IGroupedFilters;

  /**
   * ALL AVAILABLE FILTER OPTIONS
   */
  @Prop()
  filter!: PaginationFilterListElement;

  get isBooleanFilter() {
    return this.value?.filterOption?.type === PageFilterTypes.BOOLEAN;
  }

  get isComparatorSelection() {
    return ![PageFilterTypes.BOOLEAN].includes(this.value?.filterOption?.type as PageFilterTypes);
  }

  get typeInputWidthStyle() {
    if (!this.value) {
      return "min-width:  calc(100% - 24px)";
    }

    const isComparatorSelection = this.isComparatorSelection;

    return `min-width: calc(40% - 24px ${isComparatorSelection ? "- 45px" : ""}) !important`;
  }

  get valueInputWidthStyle() {
    return "min-width: calc(60% - 24px) !important";
  }

  get allOperations() {
    return Object.values(PaginationFilterOperationEnum);
  }

  get availableOperations() {
    if (PageFilterTypes.DATE === this.value?.filterOption?.type) {
      // Not equal does not work for dates in backend
      return this.allOperations.filter(op => op !== PaginationFilterOperationEnum.NOT_EQUAL);
    }

    return this.allOperations;
  }

  keyFilter(item: PaginationFilterListElement, queryText: string) {
    return (JSON.stringify(item) + $t(item.displayName ?? "objects." + item.key))
      .toLowerCase()
      .includes(queryText.toLowerCase());
  }

  addFilter() {
    this.value.filter.push(
      new PageFilterElement({
        key: this.value.filterOption.key,
        operation: PageFilterOperationEnum.EQUAL,
        value: "",
        type: this.value.filterOption.type
      })
    );
    this.$emit("input", this.value);
  }

  removeFilter(index: number) {
    this.value.filter.splice(index, 1);
    // if (!this.value.filter.length) {
    //   this.addFilter();
    // }
    this.$emit("input", this.value);
  }
}
